export const PRIMARY_FONT = 'Open-Sans';